var map = {
	"./en/privacy-policy.md": [
		8597,
		597
	],
	"./en/terms-conditions.md": [
		1936,
		936
	],
	"./es/privacy-policy.md": [
		6965,
		965
	],
	"./es/terms-conditions.md": [
		2019,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9673;
module.exports = webpackAsyncContext;